import { generateClient } from "aws-amplify/api";
const client = generateClient();
import { list_medication_masters } from '@/graphql/queries'

export default {
  data() {
    return {
      medicationsList: [],
    }
  },
  methods: {
    async fetchMedications(input) {
      try {
        const response = await client.graphql({
          query: list_medication_masters,
          variables: {
            input: {
              medication_master_id: input
            }
          }
        })

        let responseData = JSON.parse(response.data.list_medication_masters)
        // console.log(responseData)
        if (responseData.status == "SUCCESS") {
          this.medicationsList = (responseData.data || []).filter(
            (item) => item.medication_status !== "DEACTIVE"
          )
        } else {
          this.medicationsList = []
        }
        // console.log(this.medicationsList)

      } catch (error) {
        console.error("Error fetching medications:", error);
        if (error == 'NoValidAuthTokens: No federated jwt') {
          this.$router.push("/login");
          this.$store.dispatch("logout");
          this.$store.dispatch("clearAuth");
          this.$store.dispatch("clearUser");
          this.$store.dispatch("clearToken");
          this.$store.dispatch("clearRefreshToken");
          this.$store.dispatch("clearExpiresAt");
          this.$store.dispatch("clearExpiresIn");
        }
        this.medicationsList = [];
        throw error;
      }
    },
  },
};

